module.exports = __webpack_public_path__ + "img/124.42555804.jpg";